import { BrowserRouter } from "react-router-dom";
import Routes from "Routes";
import "styles/App.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { useDeviceStore } from "shared/stores/deviceStore";

const App = () => {
  const isMobile = useDeviceStore((state) => state.isMobile);

  return (
    <BrowserRouter>
      <MantineProvider>
        <Notifications containerWidth={isMobile ? "auto" : undefined} />
        <Routes />
      </MantineProvider>
    </BrowserRouter>
  );
};

export default App;
